import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaBarcode, FaUsers, FaLaptop, FaWarehouse, FaHistory, FaSignOutAlt, FaBox, FaQrcode } from "react-icons/fa";
import { Bell } from "react-bootstrap-icons";
import { Logo } from "./Login.style";

const NavbarTop = () => {
  return (
    <Navbar bg="light" expand="lg" className="px-4">
      <Navbar.Brand as={Link} to="/">
        <Logo />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ms-auto">
          <Nav.Link as={Link} to="/dashboard">
            <FaBarcode className="me-2" /> Skanuj kod
          </Nav.Link>
          <hr />
          <Nav.Link as={Link} to="/qr-management">
            <FaQrcode className="me-2" /> Zarządzanie kodami QR
          </Nav.Link>
          <hr />
          <Nav.Link as={Link} to="/users">
            <FaUsers className="me-2" /> Lista pracowników
          </Nav.Link>
          <hr />
          <Nav.Link as={Link} to="/devices">
            <FaLaptop className="me-2" /> Spis wyposażenia
          </Nav.Link>
          <hr />
          <Nav.Link as={Link} to="/stock">
            <FaWarehouse className="me-2" /> Stany magazynowe
          </Nav.Link>
          <hr />
          <Nav.Link as={Link} to="/magazyn-stali">
            <FaBox className="me-2" /> Magazyn stali
          </Nav.Link>
          <hr />
          <Nav.Link as={Link} to="/logs">
            <FaHistory className="me-2" /> Historia i raporty
          </Nav.Link>
          <hr />
          <Nav.Link as={Link} to="/notification">
            <Bell className="me-2" /> Powiadomienia
          </Nav.Link>
          <hr />
          <Nav.Link as={Link} to="/logout">
            <FaSignOutAlt className="me-2" /> Wyloguj się
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavbarTop;
